import { useState } from 'react'

export const useSelectCollectionModalFilterParams = () => {
  const [collectionName, setCollectionName] = useState<string>()
  const [status, setStatus] = useState<string>()

  return {
    filterParams: {
      collectionName,
      status,
    },
    setCollectionName,
    setStatus,
  }
}
